(() => {
  // app/scripts/common/function/ymmUtils.js
  function getFitmentTableData(config, variantIds) {
    if (config) {
      const { appName, shopName } = config;
      var FITMENT_TABLE_API = `/apps/${appName}/api/elastic/products-${shopName}/_search`;
      return new Promise((resolve, reject) => {
        fetch(FITMENT_TABLE_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            _source: {
              exclude: []
            },
            from: 0,
            size: 100,
            query: {
              bool: {
                must: [
                  {
                    nested: {
                      path: "variants",
                      query: {
                        bool: {
                          should: variantIds.map((id) => ({ match: { "variants.id": id } })),
                          minimum_should_match: 1
                        }
                      }
                    }
                  }
                ]
              }
            }
          })
        }).then((res) => res.json()).then((res) => resolve(res?.hits?.hits)).catch((error) => reject(error));
      });
    }
  }

  // app/scripts/product-description.js
  var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  var cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
  customElements.define("product-description-component", class productDescription extends HTMLElement {
    constructor() {
      super();
      this.scriptElement = document.querySelector('script[type="application/json"].object-product');
      this.JSON = this.scriptElement ? JSON.parse(this.scriptElement.textContent).product : window.theme.product;
      if (document.querySelector(".ymm-config")) {
        this.config = JSON.parse(document.querySelector(".ymm-config")?.textContent);
      }
      this.renderVehicleFitment();
      this.addEventListener("click", (e) => {
        const { target } = e;
        if (target.closest(".tab-content--heading")) {
          e.preventDefault();
          this.toggleTab(target);
        }
        if (target.closest(".jsScrollTo") && target.closest("sticky-component.active")) {
          e.preventDefault();
          this.scrollTo(target.closest(".jsScrollTo").dataset.scroll);
        }
      });
      this.template = this.querySelector("[data-variant-template]")?.content || null;
      this.querySelectorAll(".tab-content-title").forEach((tabMobile) => {
        tabMobile.addEventListener("click", (e) => {
          this.querySelectorAll("details").forEach((tab) => {
            if (tab != tabMobile.closest("details")) {
              tab.open = false;
            }
          });
        });
      });
      if (window.matchMedia("(max-width: 749px)").matches) {
        this.openFirstTab();
      }
    }
    async renderVehicleFitment() {
      const variantIds = [...new Set(this.JSON.variants.map((v) => v.id))];
      const fitmentData = await getFitmentTableData(this.config, variantIds);
      const ymmlist = fitmentData[0]._source.ymms;
      if (ymmlist.length > 0) {
        ymmlist.sort((a, b) => parseInt(b.year) - parseInt(a.year));
        this.querySelector(".jsVehicleFitmentContent").innerHTML = ymmlist.map((ymm) => {
          const ymmString = `vehicle_type=${ymm.vehicle_type}&year=${ymm.year}&make=${ymm.make}&model=${ymm.model.replaceAll(" ", "+")}`;
          return `<div class="vehicle-item" data-ymm="${ymmString}">
					${ymm.year} ${ymm.make} ${ymm.model}
				</div>`;
        }).join("");
        this.querySelectorAll(".vehicle-item").forEach((item) => {
          item.addEventListener("click", this.handleVehicleItemClick.bind(this));
        });
      } else {
        this.querySelector(".heading-vehicle-fitments").remove();
        this.querySelector(".tab-vehicle-fitments").remove();
      }
    }
    handleVehicleItemClick(event) {
      const vehicleItem = event.currentTarget;
      const ymmData = vehicleItem.getAttribute("data-ymm");
      if (ymmData) {
        try {
          sessionStorage.setItem("garageSelected", ymmData);
          console.log("YMM selection saved to localStorage");
        } catch (error) {
          console.warn("Failed to save YMM selection to localStorage:", error);
        }
        const collectionUrl = `/collections/all?${ymmData}`;
        console.log("Redirecting to:", collectionUrl);
        window.location.href = collectionUrl;
      }
    }
    toggleTab(element) {
      this.querySelectorAll(".tab-content--heading.active").forEach((button) => {
        const tabEl2 = this.querySelector(`#${button.getAttribute("aria-controls")}`);
        button.classList.remove("active");
        tabEl2.classList.remove("active");
      });
      const tabEl = this.querySelector(`#${element.getAttribute("aria-controls")}`);
      element.classList.add("active");
      tabEl.classList.add("active");
    }
    scrollTo(selector) {
      const targetOffsetTop = document.querySelector(selector).getBoundingClientRect().top + document.documentElement.scrollTop;
      const bottom = this.querySelector("sticky-component").getBoundingClientRect().top;
      window.scrollTo({
        top: targetOffsetTop - bottom,
        behavior: "smooth"
      });
    }
    openFirstTab() {
      this.querySelector("details").open = true;
    }
  });
})();
